import { FormattedMessage } from "react-intl";
import FullScreenDialog from "../../../../common/core-ui/FullScreenDialog";
import DotLoader from "../../../../common/core-ui/DotLoader";
import styles from "./UpdatingLibraryDialog.module.scss";

export default function UpdatingLibraryDialog({
  onRequestClose,
}: {
  onRequestClose: () => void;
}) {
  return (
    <FullScreenDialog
      onRequestClose={onRequestClose}
      className={styles.dialog}
      hideCloseButton
    >
      <div className={styles.content}>
        <DotLoader />
        <div className={styles.updating}>
          <FormattedMessage defaultMessage="Updating Library" />
        </div>
        <div>
          <FormattedMessage defaultMessage="This may take a few moments" />
        </div>
      </div>
    </FullScreenDialog>
  );
}
